import { useCallback, useEffect, useState } from 'react';

export const useCountDown = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => clearTimeout(timerId);
  }, [seconds]);

  const start = useCallback((from: number) => {
    setSeconds(from);
  }, []);

  return {
    seconds,
    start,
  };
};
